/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRun } from './ApiRun';
import { ApiRunFromJSON, ApiRunFromJSONTyped, ApiRunToJSON, ApiRunToJSONTyped } from './ApiRun';
import type { ApiPipelineRuntime } from './ApiPipelineRuntime';
import {
  ApiPipelineRuntimeFromJSON,
  ApiPipelineRuntimeFromJSONTyped,
  ApiPipelineRuntimeToJSON,
  ApiPipelineRuntimeToJSONTyped,
} from './ApiPipelineRuntime';

/**
 *
 * @export
 * @interface ApiRunDetail
 */
export interface ApiRunDetail {
  /**
   *
   * @type {ApiRun}
   * @memberof ApiRunDetail
   */
  run?: ApiRun;
  /**
   *
   * @type {ApiPipelineRuntime}
   * @memberof ApiRunDetail
   */
  pipeline_runtime?: ApiPipelineRuntime;
}

/**
 * Check if a given object implements the ApiRunDetail interface.
 */
export function instanceOfApiRunDetail(value: object): value is ApiRunDetail {
  return true;
}

export function ApiRunDetailFromJSON(json: any): ApiRunDetail {
  return ApiRunDetailFromJSONTyped(json, false);
}

export function ApiRunDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRunDetail {
  if (json == null) {
    return json;
  }
  return {
    run: json['run'] == null ? undefined : ApiRunFromJSON(json['run']),
    pipeline_runtime:
      json['pipeline_runtime'] == null
        ? undefined
        : ApiPipelineRuntimeFromJSON(json['pipeline_runtime']),
  };
}

export function ApiRunDetailToJSON(json: any): ApiRunDetail {
  return ApiRunDetailToJSONTyped(json, false);
}

export function ApiRunDetailToJSONTyped(
  value?: ApiRunDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    run: ApiRunToJSON(value['run']),
    pipeline_runtime: ApiPipelineRuntimeToJSON(value['pipeline_runtime']),
  };
}
